/* eslint-disable no-console */
import { AxiosError } from "axios";
import { SiteApi } from "../../../utils/api/siteApi";
import { IMembershipContentResponse } from "./getMembershipContentApi.types";

const BaseUrl = `${
  (window as any).currentEnvironment.REACT_APP_API_OPTIMIZELY_URL
}`;

export const getMembershipContent = async (language: string) => {
  try {
    return await SiteApi.Get<IMembershipContentResponse>(
      `${BaseUrl}/api/v1/membership/content?language=${language}`
    );
  } catch (err) {
    console.error("error: ", err);
    return (err as AxiosError).response;
  }
};

export default {};
